module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/114-british-virgin-islands-78910b26a10a47bdb8ea3aad52a51871.svg";